import { render, staticRenderFns } from "./AllowedReportsView.vue?vue&type=template&id=7790f4e5&scoped=true&"
import script from "./AllowedReportsView.vue?vue&type=script&lang=js&"
export * from "./AllowedReportsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7790f4e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VLayout})
